import { FormatUtils } from '@shared/utils';
import { ColorsEnum, Text } from '@shared/widgets';

interface IAccountInfoRowProps {
  divider?: boolean;
  text?: string;
  number?: string;
}

export const AccountInfoRow = (props: IAccountInfoRowProps) => {
  return (
    <div className='mb-3 flex items-baseline justify-between gap-3 last:mb-0'>
      {props.divider && <div className='h-[1px] w-full bg-light opacity-40' />}
      {props.text && props.number && (
        <>
          <Text color={ColorsEnum.Secondary} size='sm'>
            {props.text}
          </Text>
          <Text weight='medium' size='sm'>
            {props.number && FormatUtils.toSliceNumber(props.number)}
          </Text>
        </>
      )}
    </div>
  );
};
